import React from 'react';
import lockIcon from 'assets/icons/hex-lock-icon.svg';

const CostBasisErrorV2 = ({ name = '' }) => {
  return (
    <div className="cost-basis-section-error-lock-icon-container-v2 cds-error">
      <img src={lockIcon} alt="lock icon" />
      <div className="cost-basis-error-content">
        <p className="b-typography-sans-serif--body--200 b-font-weight-bold ">
          Data unable to load
        </p>
        <p className=" cost-basis-section-error-paragraph b-typography-sans-serif--body--100 b-font-weight-light ">
          {name} data could not be retrieved, please try again.
        </p>
      </div>
    </div>
  );
};

export default CostBasisErrorV2;
